<template>
	<img v-if="imageUrl && !imageErrors[imageUrl]" :src="imageUrl" alt="" @error="imageLoadError(imageUrl)">
	<SvgUser v-else />
</template>

<script setup>
import { ref } from "vue"
import SvgUser from "@/svg/customer/images/user.svg"

// Props
defineProps({
	imageUrl: {
		type: String,
		default: null
	}
})

// Reactives
const imageErrors = ref({})

// Methods
function imageLoadError(url){
	imageErrors.value[url] = true
}
</script>